import { Button, Row, Col, message } from 'antd';
import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import Loader from '@iso/components/utility/loader';
import ApiStock from '@iso/services/repository/stock';
import CardWrapper, { Box } from '../Bill/Bill.style';
import { useDispatch, useSelector } from 'react-redux';
import ApiPeople from '@iso/services/repository/people';
import notification from '@iso/components/Notification';
import productActions from '@iso/redux/products/actions';
import ButtonEdit from '@iso/components/uielements/button';
import ApiPurschase from '@iso/services/repository/purchase';
import { Link, useParams, useHistory } from 'react-router-dom';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import { findObjIntoArrayByProp } from '@iso/lib/helpers/utility';
import Select, { SelectOption } from '@iso/components/uielements/select';
import AutoComplete from '@iso/components/Integration/NotaFiscal/AutoComplete';
import {Label} from '@iso/containers/Registration/People/SinglePeople.styles.js';
import NewProductModal from '@iso/components/Registration/Product/NewProductModal';
import NewSuppliersForProductModal from '@iso/components/Registration/Product/NewSuppliersForProductModal';

const Option = SelectOption;
const { initData } = productActions;

export default function EditForm({ compraId: idProp, onSaved, onCancel, inModal = false, footerEl = null } = {}) {

    let history = useHistory();
    const dispatch = useDispatch();
    const params = useParams();
  const compraId = idProp !== undefined ? idProp : params.compraId;

    const refNewProductModal = useRef();
    const refNewSuppliersForProductModal = useRef();

    const [load, setLoad] = useState(true)
    const [suppliers, setSuppliers] = useState([])
    const [stockItens, setStockItens] = useState([]);
    const [selectAll, setSelectAll] = useState(false)
    const [hasStarted, setHasStarted] = useState(true)
    const [auxProducts, setAuxProducts] = useState({})
    const [selectedProds, setSelectedProds] = useState([])
    const [selectedSuppliers, setSelectedSuppliers] = useState({})
    const [purchase, setPurchase] = useState({ market: 'N', type: 'A', products: {} })

    const { initialProducts, products } = useSelector((state) => state.Products);

    React.useEffect(() => {
        getStock();
        getAllSuppliers();
    }, []);

    React.useEffect(() => {
        if (compraId !== '0') {
            ApiPurschase.getById(compraId).then((response) => {
                if (!response.data.error) {
                    let data = response.data;
                    setPurchase(data)
                    let auxPds = [];
                    for (const id in data.products) {
                        if (!Object.hasOwn(data.products, id)) continue;
                        
                        auxPds.push(id)
                    }

                    setSelectedProds(auxPds);
                }
                setLoad(false);
            })
            .catch((err) => {
                console.error("ops! ocorreu um erro" + err);
            });
        }
        else
            setLoad(false);
    }, [compraId]);

    const getAllSuppliers = () => {
        ApiPeople.getAllSuppliers().then(res => {
            setSuppliers(res.data)
        })
    }

    React.useEffect(() => {
    if (!initialProducts)
        dispatch(initData());
    else
        iterateProds(products);
    }, [dispatch, initialProducts]);

    const iterateProds = (prods) => {
        try {
            let aux = {};
            prods.forEach(element => {
                element.suppliersOptions = makeSuppliersFromProduct(element?.suppliers);
                aux[element._id] = element;
            });
            setAuxProducts(aux);
        } catch (error) {
            console.log('iterateProds error: ', error)
        }
    }

    const getStock = () => {
        try {
            ApiStock.getAllSmall().then(res => {

                let auxData = [...res.data], allItens = [];

                auxData.forEach((element, i) => {
                    if(element.minimumStock > 0 && element.minimumStock >= element.currentStock ) {
                        element.produto = `${element.name} | ${element.sku}`

                        allItens.push(element);
                    }
                });

                setStockItens(allItens);
            })

        } catch (error) {
            console.log('getStock Error: ', error)
        }
    }

    const changeSelectedSuppliers = (id, val) => {
        try {
            let auxPS = { ...purchase.products }
            if (typeof auxPS[id] === 'undefined') {
                auxPS[id] = {};
                auxPS[id]['qtd'] = auxProducts[id]['minimumStock']
            }

            auxPS[id]['suppliers'] = val;

            setPurchase((old) => {
                return { ...old, products: auxPS }
            })
        } catch (error) {
            console.log('changeSelectedSuppliers Error: ', error)
        }
    }

    const getSupplier = (id) => {
        try {
            let idx = findObjIntoArrayByProp(suppliers, '_id', id);
            return (idx !== -1) ? suppliers[idx]['name'] : '';
        } catch (error) {
            console.log('getSupplier Error: ', error)
        }
    }

    const makeSuppliersFromProduct = (suppliers) => {
        try {
            return suppliers.map(s => ({
                key: s,
                value: s,
                label: getSupplier(s)
            }))
        } catch (error) {
            console.log('makeSuppliersFromProduct Error: ', error)
        }
    }

    const searchSuppliers = (id) => {
        try {
            if(typeof id === 'undefined')
                notification('error', 'Primeiro selecione o produto');
            else
                refNewSuppliersForProductModal.current.showNewSuppliersForProductModal(id);
        } catch (error) {
            console.log('searchSuppliers Error: ', error)
        }
    }

    const changeMe = (e) => {
        try {
            let id = e.target.value;
            let checked = e.target.checked;
            let auxSelectedProds = [...selectedProds];

            let idx = auxSelectedProds.indexOf(id);

            if(checked && idx === -1 )
                auxSelectedProds.push(id);
            else if( !checked && idx !== -1)
                auxSelectedProds.splice(idx, 1);
            
            let aux = { ...purchase }

            if(typeof aux.products[id] === 'undefined') {
                idx = findObjIntoArrayByProp(stockItens, 'productId', id)
                if(idx !== -1)
                    aux.products[id] = {
                        'suppliers':[],
                        'qtd':stockItens[idx].minimumStock || 0
                    }
            }

            setSelectedProds(auxSelectedProds)
        } catch (error) {
            console.log('changeMe Error: ', error)
        }
    }

    const changeAll = () => {
        try {
            const itemCheckboxes = document.querySelectorAll('.item-checkbox');

            let auxSelectds = [...selectedProds]

            if (selectAll) {
                setSelectAll(false)
                auxSelectds = [];
                itemCheckboxes.forEach(checkbox => {
                    checkbox.checked = false;
                });
            }
            else {
                itemCheckboxes.forEach(checkbox => {
                    checkbox.checked = 'checked';
                });
                
                let aux = { ...purchase }

                stockItens.forEach(p => {
                    if(auxSelectds.indexOf(p.productId) === -1)
                        auxSelectds.push(p.productId)

                    if(typeof aux.products[p.productId] === 'undefined')
                        aux.products[p.productId] = {
                            'suppliers':[],
                            'qtd':p.minimumStock || 0
                        }
                });

                setPurchase((old) => {
                    return { ...old, products: aux.products }
                })

                setSelectAll(true)
            }

            setSelectedProds(auxSelectds)
        } catch (error) {
            console.log('changeAll Error: ', error)
        }
    }

    const requestNewProduct = () => {
        refNewProductModal.current.showNewProductModal();
    }

    const handleSubmit = () => {
        let aux = { ...purchase }

        try {
            if(Object.keys(aux.products).length === 0) {
                notification('error', 'Selecione pelo menos 1 produto!')
                return false;
            }

            for (const id in aux.products) {
                if (!Object.hasOwn(aux.products, id)) continue;

                if(selectedProds.indexOf(id) === -1)
                    delete aux.products[id];            
            }

            delete aux['product'];

            if (compraId !== '0') {
                ApiPurschase.update(aux).then(res => {
                    if (typeof res.data.error === 'undefined') {
                        notification('success', 'Compra atualizada com sucesso')
                        if (onSaved) onSaved(); else history.push('/dashboard/compras-internacionais');
                    }
                    else
                        notification('error', res.data.message)
                })
            }
            else {
                ApiPurschase.create(aux).then(res => {
                    if (typeof res.data.error === 'undefined') {
                        notification('success', 'Compra cadastrada com sucesso')
                        if (onSaved) onSaved(); else history.push('/dashboard/compras-internacionais');
                    }
                    else
                        notification('error', res.data.message)
                })
            }
    
        } catch (error) {
            console.log('handleSubmit error: ', error)   
        }
    }

    const handleChangeQtd = (e, id) => {
        var valor = e.target.value;

        let auxPS = { ...purchase.products }
        if (typeof auxPS[id] === 'undefined')
            auxPS[id] = {};

        auxPS[id]['qtd'] = valor;

        setPurchase((old) => {
            return { ...old, products: auxPS }
        })
    }

    const addNewSuppliers = (data, id) => {
        try {
            let aux = { ...auxProducts }
            aux[id]['suppliersOptions'] = data.map(s => {
                return {
                    key: s._id,
                    value: s._id,
                    label: s.name
                }
            });
            setAuxProducts(aux);
        } catch (error) {
            console.log('addNewSuppliers error: ', error)
        }
    }

    const addNewProduct = (data) => {
        let aux = [...products];
        aux.push(data);
        iterateProds(aux);

        aux = { ...purchase };
        aux['product'] = { name: data.name, _id: data._id, suppliersOptions: [] };

        setPurchase({ ...aux });
    }

  const actionButtons = (
    <>
      {inModal ? (
        <Button color="primary" onClick={onCancel}><span>Cancelar</span></Button>
      ) : (
        <Link to="/dashboard"><Button color="primary"><span>Cancelar</span></Button></Link>
      )}
      <Button type="primary" onClick={handleSubmit} className="saveBtn"><span>Salvar</span></Button>
    </>
  );
  const actionsRender = footerEl ? createPortal(actionButtons, footerEl) : (
    <div style={{ display: ('flex'), justifyContent: ('flex-end'), gap: 8, padding: '10px 4px 20px' }}>{actionButtons}</div>
  );
    return (
        <LayoutWrapper>
            {inModal ? null : (
              <PageTitleBar title={`${purchase._id ? 'Editar' : 'Nova'} compra`} backTo="/dashboard/compras-internacionais" />
            )}
            {actionsRender}
            <Box style={{ border: 'none', boxShadow: 'none' }}>
                {!hasStarted ? (
                    <Loader />
                ) : (
                    <CardWrapper>
                        <Box style={{ marginBottom: '5px' }}>
                            <Row gutter={24} style={{ marginTop: '-10px' }}>
                                <Col span={4}>
                                    <div style={{ padding: '5px' }}>
                                        <Label>Mercado de compra</Label>
                                        <Select
                                            className="ant-input"
                                            value={purchase?.market}
                                            placeholder="Selecione a opção"
                                            onChange={(e) => {
                                                setPurchase(prevState => {
                                                    return { ...prevState, market: e }
                                                });
                                            }}
                                        >
                                            <Option key={'N'} value={'N'}>Nacional</Option>
                                            <Option key={'I'} value={'I'}>Internacional</Option>
                                        </Select>
                                    </div>
                                </Col>
                                <Col span={4}>
                                    <div style={{ padding: '5px' }}>
                                        <Label>Tipo de compra</Label>
                                        <Select
                                            className="ant-input"
                                            value={purchase?.type}
                                            placeholder="Selecione a opção"
                                            onChange={(e) => {
                                                setPurchase(prevState => {
                                                    return { ...prevState, type: e }
                                                });
                                            }}
                                        >
                                            <Option key={'A'} value={'A'}>Avulsa</Option>
                                            <Option key={'E'} value={'E'}>Estoque mínimo</Option>
                                        </Select>
                                    </div>
                                </Col>
                            </Row>
                        </Box>
                        {
                            (purchase.type === 'E') ?
                                <Box style={{ marginBottom: '12px', marginTop: '10px' }}>
                                    {/* title="Produtos com estoque mínimo" */}
                                    <Row gutter={24}>
                                        <Col span={24}>
                                            <Row gutter={24} style={{ marginBottom: '10px' }}>
                                                <Col span={1}>
                                                    <input type='checkbox' checked={selectAll} onClick={changeAll} style={{marginLeft:'5px'}}/>
                                                </Col>
                                                <Col span={7}><b>Nome do produto</b></Col>
                                                <Col span={2} style={{ textAlign: 'right' }}><b>Código</b></Col>
                                                <Col span={2} style={{ textAlign: 'right' }}><b>Est. mínimo</b></Col>
                                                <Col span={2} style={{ textAlign: 'right' }}><b>Qtd. compra</b></Col>
                                                <Col span={9}><b>Fornecedores</b></Col>
                                                <Col span={1}>&nbsp;</Col>
                                            </Row>
                                            {
                                                stockItens.map(p => {
                                                    return <Row gutter={24} style={{borderBottom: '1px #DDD solid', padding: '5px'}}>
                                                        <Col span={1}>
                                                            <input type='checkbox' className='item-checkbox' value={p.productId} checked={selectedProds.indexOf(p.productId) !== -1} onClick={changeMe}/>
                                                        </Col>
                                                        <Col span={7}>{p.produto}</Col>
                                                        <Col span={2} style={{ textAlign: 'right' }}>{p.sku}</Col>
                                                        <Col span={2} style={{ textAlign: 'right' }}>{p.minimumStock}</Col>
                                                        <Col span={2}>
                                                            <input type='number' style={{ textAlign: 'right' }} defaultValue={p.minimumStock} value={purchase?.products[p.productId]?.qtd} className="ant-input"
                                                                onChange={(e) => handleChangeQtd(e, p.productId)} />
                                                        </Col>
                                                        <Col span={9}>
                                                            <Select
                                                                allowClear
                                                                mode="multiple"
                                                                style={{ width: '100%' }}
                                                                value={selectedSuppliers[p.productId]}
                                                                placeholder="Selecione os fornecedores"
                                                                options={auxProducts[p.productId]?.suppliersOptions || []}
                                                                onChange={(e) => changeSelectedSuppliers(p.productId, e)}
                                                            />
                                                        </Col>
                                                        <Col span={1}>
                                                            <Button type='primary' onClick={() => searchSuppliers(p.productId)} title='Buscar novos fornecedores' className="ant-input" 
                                                                style={{ fontWeight: 'bold' }}>+</Button>
                                                        </Col>
                                                    </Row>
                                                })
                                            }
                                        </Col>
                                    </Row>
                                </Box>
                                :
                                <Box style={{ marginBottom: '12px', marginTop: '10px' }}>
                                    <Row gutter={24}>
                                        <Col span={11}>
                                            <Label>Produto para compra avulsa</Label>
                                            <AutoComplete
                                                name={"product"}
                                                dataArray={
                                                    products.map(inv => ({
                                                        id: inv._id,
                                                        name: `${inv.name} | ${inv.sku}`,
                                                        value: `${inv.name} | ${inv.sku}`,
                                                        suppliersOptions: auxProducts[inv._id]?.suppliersOptions
                                                    }))
                                                }
                                                value={purchase?.product?.name}
                                                handleChange={(e, item) => {
                                                    let aux = { ...purchase };
                                                    if (item !== undefined)
                                                        aux['product'] = { name: item.name, _id: item.id, suppliersOptions: item?.suppliersOptions };
                                                    else
                                                        aux['product'] = null;

                                                    setPurchase({ ...aux });
                                                }}
                                            />
                                        </Col>
                                        <Col span={1}>
                                            <Button type='primary' onClick={requestNewProduct} title='Cadastrar novo produto' className="ant-input"
                                                 style={{ fontWeight: 'bold', marginTop: '22px' }}>+</Button>
                                        </Col>
                                        <Col span={9}>
                                            <Label>Fornecedores</Label>
                                            <Select
                                                allowClear
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                placeholder="Selecione os fornecedores"
                                                value={selectedSuppliers[purchase?.product?._id]}
                                                options={auxProducts[purchase?.product?._id]?.suppliersOptions || []}
                                                onChange={(e) => changeSelectedSuppliers(purchase?.product?._id, e)}
                                            />
                                        </Col>
                                        <Col span={1}>
                                            <Button type='primary' onClick={()=>searchSuppliers(purchase?.product?._id)} title='Buscar novos fornecedores' className="ant-input" 
                                                style={{ fontWeight: 'bold', marginTop: '22px' }}>+</Button>
                                        </Col>
                                        <Col span={2} style={{ textAlign: 'center' }}>
                                            <Label>Quantidade</Label>
                                            <input placeholder='Quantidade' type='number' style={{ textAlign: 'right' }} defaultValue={1} className="ant-input" 
                                                onChange={(e) => handleChangeQtd(e, purchase?.product?._id)} />
                                        </Col>
                                    </Row>
                                </Box>
                        }
                    </CardWrapper>
                )}
            </Box>
            <NewProductModal ref={refNewProductModal} onSave={addNewProduct}/>
            <NewSuppliersForProductModal ref={refNewSuppliersForProductModal} onSave={addNewSuppliers}/>
        </LayoutWrapper>
    );
}